import { object, string, array, number, boolean, SchemaOf } from 'yup';

import { ChangeWindow } from '../../../types';

import {
  IngressController,
  KubernetesSetupFormValues,
  StorageClass,
} from './types';

const ingressControllerSchema: SchemaOf<IngressController> = object({
  name: string().required(),
});

const storageClassSchema: SchemaOf<StorageClass> = object({
  name: string().required(),
  accessModes: array(string().required()).required(),
  allowVolumeExpansion: boolean().required(),
});

const changeWindowSchema: SchemaOf<ChangeWindow> = object({
  Enabled: boolean().required(),
  StartTime: string().required(),
  EndTime: string().required(),
});

export const kubernetesSetupValidationSchema: SchemaOf<KubernetesSetupFormValues> =
  object({
    // PolicyConfigFormValues
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),

    // Networking - Services
    useLoadBalancer: boolean().required(),

    // Networking - Ingresses
    ingressControllers: array(ingressControllerSchema),
    allowNoneIngressClass: boolean().required(),
    ingressAvailabilityPerNamespace: boolean().required(),
    restrictStandardUserIngressW: boolean().required(),

    // Change Window
    changeWindow: changeWindowSchema,

    // Resources and Metrics
    enableResourceOverCommit: boolean().required(),
    resourceOverCommitPercentage: number().required(),
    useServerMetrics: boolean().required(),

    // Storage
    storageClasses: array(storageClassSchema),
  });
